module.exports = __webpack_public_path__ + "static/img/liaotian.04388864.png";